import React, { useRef, useState } from 'react'
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'

// import required modules
import { Pagination, Navigation } from 'swiper/modules'
import BlurText from './Animations/BlurText'
import AnimatedContent from './Animations/AnimatedContent'
import ShinyText from './Animations/ShinyText'
import GradientText from './Animations/GradientText'
import Waves from './Animations/Waves'
import SplitText from './Animations/SplitText'
import SpotlightCard from './Animations/SpotlightCard'

const DATA = [
    {
        number: '01',
        heading: "🎧 Voice-Powered Trading",
        description: `Transform your trading experience with instant, voice-activated commands. Execute trades, check your portfolio, or set targets—all hands-free.
- “Buy 2 ETH at $1,700.”
- “Sell my Ethereum when it reaches $2,000.”
- “What’s my portfolio performance for the past week?”`,
        img: "/images/slider-1.png",
    },
    {
        number: '02',
        heading: "Real - Time Market Insights",
        description: `Stay informed with AI-driven analysis and up-to-the-second market updates tailored to Ethereum’s ecosystem.
- “What’s the current sentiment around Ethereum?”
- “Show me today’s top gainers and losers on Ethereum.”
- “What’s the current gas fee on the Ethereum network?”`,
        img: "/images/slider-2.png",
    },
    {
        number: '03',
        heading: "🛠️ Portfolio Management Made Simple",
        description: `Manage and optimize your crypto holdings effortlessly with intuitive voice commands.
- “Rebalance my portfolio to 60% ETH and 40% USDT.”
- “Withdraw $300 USDT to my Ethereum wallet.”
- “Convert 50% of my ETH holdings to DAI.”`,
        img: "/images/slider-3.png",
    },
    {
        number: "04",
        heading: "🔔 Custom Alerts and Notifications",
        description: `Never miss a beat with personalized alerts that keep you ahead of the game:
- “Alert me when Ethereum drops below $1,500.”
- “Notify me if Ethereum gas fees fall below 20 Gwei.”
- “Send me an update if the top 10 tokens by market cap change overnight.”`,
        img: "/images/slider-4.png",
    },
    {
        number: "05",
        heading: "🎯 Precision Sniper Mode",
        description: `Take advantage of Vocal AI’s ultra-fast execution engine to seize fleeting opportunities in Ethereum’s fast-paced market. With Sniper Mode, trades are executed instantly, ensuring you never miss critical moments.`,
        img: "/images/slider-5.png",
    },
    {
        number: "06",
        heading: "🤖 Autonomous Trading Operations",
        description: `Let Vocal AI handle your portfolio, even offline, with advanced automation:
Dynamic Rebalancing: Align assets with market trends.
Arbitrage Trading: Exploit price differences on Ethereum platforms.
Risk Management: Automate stop-loss and take-profit levels.`,
        img: "/images/slider-6.png",
    },

]

export default function Slider() {
    return (
        <div
            className='lg:w-[80%] w-[90%] mx-auto md:mt-0 mt-[5vw]'
            id='Features'
        >
            <div className='py-10 relative'>
                <div className='flex tok flex-col !items-start md:w-[50%] w-full md:absolute static left-[0%] top-[5vw]'>
                    <div className='bg-black px-5 py-1 rounded-3xl w-fit md:mb-5 mb-2'>
                        <GradientText
                            colors={["#40ffaa", "#BEFFCD", "#7358F9",]}
                            animationSpeed={3}
                            showBorder={false}
                            className="font-semibold md:text-lg text-sm "
                        >
                            WHY Vocal AI
                        </GradientText>
                    </div>
                    <AnimatedContent
                        distance={150}
                        direction="vertical"
                        reverse={false}
                        config={{ tension: 80, friction: 20 }}
                        initialOpacity={0.2}
                        animateOpacity
                        scale={1.1}
                        threshold={0.2}
                    >
                        <BlurText
                            text="Core Features of Vocal AI"
                            delay={150}
                            animateBy="words"
                            direction="top"
                            className="md:text-4xl text-2xl font-medium !text-start !items-start !justify-start"
                        />
                    </AnimatedContent>
                </div>

                <div className='container mx-auto mt-[10vw]'>
                    <Swiper
                        navigation={true}
                        slidesPerView={1}
                        spaceBetween={10}
                        pagination={{
                            clickable: true,
                        }}
                        breakpoints={{
                            480: {
                                slidesPerView: 1,
                                spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            1024: {
                                slidesPerView: 2,
                                spaceBetween: 50,
                            },
                        }}
                        modules={[Navigation]}
                        className='mySwiper !relative'
                    >
                        {DATA.map((item, index) => (
                            <SwiperSlide key={index}>
                                <SpotlightCard className="bg-[#1f2021] md:p-[50px] p-5  border border-[#343537] shadow-xl rounded-2xl md:rounded-3xl" spotlightColor="#61FF8630">
                                    <div className='flex flex-col items-start gap-3'>
                                        <GradientText
                                            colors={["#40ffaa", "#BEFFCD", "#7358F9",]}
                                            animationSpeed={3}
                                            showBorder={false}
                                            className="font-semibold text-lg "
                                        >
                                            {item.number}
                                        </GradientText>
                                        <h1 className="md:text-3xl text-2xl font-normal !text-start">{item.heading}</h1>
                                        <ShinyText text={item.description}
                                            disabled={false} speed={3} className='mt-3' />

                                    </div>
                                    <div className='relative border border-[#343537] md:rounded-3xl rounded-2xl overflow-hidden mt-5 md:h-[25vw] h-[60vw] flex items-center justify-center p-5' >
                                        <img src={item.img} alt="" className='z-30 w-[15vw] mt-10 smooth_move_animation' />
                                        <Waves
                                            lineColor="#343537"
                                            backgroundColor="#1f2021"
                                            waveSpeedX={0.02}
                                            waveSpeedY={0.01}
                                            waveAmpX={40}
                                            waveAmpY={20}
                                            friction={0.9}
                                            tension={0.01}
                                            maxCursorMove={120}
                                            xGap={12}
                                            yGap={36}
                                        />
                                    </div>
                                </SpotlightCard>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    )
}
